import { Input } from 'antd';

interface InputMapProps {
  disabled: boolean;
}

export const InputMap = ({ disabled, ...restProps }: InputMapProps) => <Input disabled={disabled} {...restProps} />;
